module.exports = __webpack_public_path__ + "static/media/creditcard.5460039c.gif";